<template>
  <!--お知らせ管理 -->
  <div id="NoticeEdit">
    <div id="container">
      <masterNavi v-bind:pageid='"NoticeEdit"'></masterNavi>
      <div class="labelTitle lable">お知らせ管理</div>
      <div class="labelTitle lable">お知らせ（ログイン画面）</div>
        <div class="containtsArea">
          <textarea class="noticeTextArea noresize" v-model="notice.login" maxlength="1024" :disabled="!active.login"></textarea>
          <b-button class="saveButton is-primary" @click="saveLoginNotice" :disabled="!active.login">保存</b-button>
        </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/master/MasterMaintenanceBar";
export default {
  name: "NoticeEdit",
  methods: {
    saveLoginNotice: function() {
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalMaintenance.setMaintenanceAnnouncementPOST({
            body: {
              type: 0,
              contents: _this.notice.login
            }
          });
        },
        this.successSave,
        this.errorSave,
      );
    },
    saveInnerNotice: function() {
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalMaintenance.setMaintenanceAnnouncementPOST({
            body: {
              type: 1,
              contents: _this.notice.inner
            }
          });
        },
        this.successSave,
        this.errorSave,
      );
    },
    successSave: function(result){
      this.showSuccess(result);
    },
    errorSave: function(result){
      this.showErrorMessage(result);
    },
  },
  data() {
    return {
      notice:{
        login: "",
        inner: ""
      },
      active: {
        login: false,
        inner: false
      }
    };
  },
  filters: {},
  components: {
    masterNavi: naviBar,
  },
  mounted: async function(){
    var params = [
      {type:0, field: "login"},
      {type:1, field: "inner"},
    ]
    for(let param of params){
      await this.$store.dispatch("getAnnouncement", {
          type: param.type,
      }).then(result => {
        console.log(result);
        this.notice[param.field] ="お知らせを取得できませんでした。"
        if(result != null && result.status === 200 ) {
          this.notice[param.field] = result.body.contents;
        }
      }).catch(error => {
          this.notice[param.field] ="お知らせを取得できませんでした。"
      });
      this.active[param.field] = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.containtsArea {
  margin-top:10px;
  height: 250px;
}
.noticeTextArea {
  float: left;
  width: 800px;
  height: 250px;
}
.saveButton {
  float: left;
  margin-left:10px;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/master/notice/NoticeEdit.vue